import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HeaderBar from '../common/HeaderBar';
import { Loader, Dimmer } from 'semantic-ui-react';
import {InstantSearch, SearchBox, Hits, SortBy, PoweredBy, Configure} from 'react-instantsearch/dom';
import ViewSwitch from '../common/ViewSwitch';
import VolunteerHitMapView from '../common/VolunteerHitMapView';
import VolunteerHitMapMarker from '../common/VolunteerHitMapMarker';
import VolunteerListItem from '../common/VolunteerListItem';
import VolunteerHitListView from '../common/VolunteerHitListView';


const HitList = (props)=>{
    return (
        <VolunteerHitListView>
            {props.children}
            <Hits hitComponent={VolunteerListItem} />
        </VolunteerHitListView>
        
    )
}

const HitMap = (props)=>{
    return (
        <div>
            {props.children}
            <VolunteerHitMapView >
            
                <Hits hitComponent={VolunteerHitMapMarker} />
            </VolunteerHitMapView>     
        </div>
    )
}


class VolunteerScreen extends React.Component {

    constructor(props){
        super(props);
        this.onSearchBoxChange = this.onSearchBoxChange.bind(this);
        this.state = {
            loading : false,
            mode : 'list'
        }

    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    onSearchBoxChange(event){
        
        this.setState({
            // mode : (event && event.target && event.target.value) ? 'list' : 'map',
            // index : (event && event.target && event.target.value) ? 'items' : 'volunteerLocations',
            
        })
    }
    
    render(){

        const renderMapView = ()=>{
            if(this.state.mode==='list'){
                return null;
            } else {
                return (
                    <div>
                        <SearchBox onChange={this.onSearchBoxChange} onReset={this.onSearchBoxChange} translations={{placeholder : 'Search for something to do'}} />
                        <HitMap>
                            <ViewSwitch value={this.state.mode} onChange={(value)=>{ this.setState({mode : value})}} options={[{ value : 'list', text : 'List View' }, { value : 'map', text : 'Map View' }]} />
                        </HitMap>
                    </div>
                    
                )   
            }
        }

        const renderListView = ()=>{
            if(this.state.mode==='list'){
                return (
                    <div>
                        <SearchBox onChange={this.onSearchBoxChange} onReset={this.onSearchBoxChange} translations={{placeholder : 'Search for something to do'}} />
                        <HitList>
                            <ViewSwitch value={this.state.mode} onChange={(value)=>{ this.setState({mode : value})}} options={[{ value : 'list', text : 'List View' }, { value : 'map', text : 'Map View' }]} />
                        </HitList>
                    </div>
                );
            } else {
                return null
            }
        }

      
       
        return (
            <div className="VolunteerScreen">
                <HeaderBar />
                <div className="VolunteerScreen-content">
                
                {(this.state.loading)? <Dimmer inverted active>
                    <Loader>Loading</Loader>
                </Dimmer>
                : null}
                 <InstantSearch
                        apiKey="aa4db728d33cb5c9f9032ac40c2c13d8"
                        appId="R5BM8DSN2Y"
                        indexName='volunteers'
                    >
                        <Configure aroundLatLngViaIP={true}/>
                        <Configure getRankingInfo={true}/>


                        
                        
                        <br/>

                        {renderListView()}
                        <PoweredBy />
                    </InstantSearch>

                    <InstantSearch
                        apiKey="aa4db728d33cb5c9f9032ac40c2c13d8"
                        appId="R5BM8DSN2Y"
                        indexName='volunteerLocations'
                    >
                        <Configure aroundLatLngViaIP={true}/>
                        <Configure getRankingInfo={true}/>
                        
                        {renderMapView()}

                        <PoweredBy />
                    </InstantSearch>
                </div>
                <style jsx>{`
                    .VolunteerScreen-content {
                        max-width:800px;
                        margin:auto;
                    }
                `}</style>
            </div>
        )
    }
}

VolunteerScreen.propTypes = {
    
}

const mapStateProps = (state) => {
    return {
    
    };
}

export default  connect(mapStateProps, {  })(VolunteerScreen);



// WEBPACK FOOTER //
// ./src/components/screens/VolunteerScreen.js